import { render, staticRenderFns } from "./EventListModal.vue?vue&type=template&id=0ab90ed4&scoped=true&"
import script from "./EventListModal.vue?vue&type=script&lang=ts&"
export * from "./EventListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab90ed4",
  null
  
)

export default component.exports